var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        { staticClass: "pt-3" },
        [
          _c("h3", [
            _vm._v(
              _vm._s(
                _vm.objectTypeRecommendations ? "Recommendations" : "Quick Wins"
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "b-card",
            { staticClass: "mb-1", attrs: { "no-body": "" } },
            [
              _c(
                "b-card-header",
                {
                  staticClass: "p-1",
                  attrs: { "header-tag": "header", role: "tab" }
                },
                [
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.accordion1",
                          modifiers: { accordion1: true }
                        }
                      ],
                      attrs: { block: "", href: "#", variant: "primary" }
                    },
                    [
                      _vm._v("\n        Search Criteria \n        "),
                      !_vm.showSearch
                        ? _c("font-awesome-icon", {
                            attrs: { icon: "caret-down", size: "lg" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSearch
                        ? _c("font-awesome-icon", {
                            attrs: { icon: "caret-up", size: "lg" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  attrs: {
                    id: "accordion1",
                    visible: "",
                    accordion: "accordion1",
                    role: "tabpanel"
                  },
                  model: {
                    value: _vm.showSearch,
                    callback: function($$v) {
                      _vm.showSearch = $$v
                    },
                    expression: "showSearch"
                  }
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "pt-2", attrs: { "align-h": "center" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("scoring-event-search", {
                            attrs: {
                              skip: {},
                              multiple: {
                                region: true
                              }
                            },
                            on: {
                              "update:customer": function($event) {
                                _vm.customerId = ($event || {}).id
                              },
                              "update:industry": function($event) {
                                _vm.industry = $event
                              },
                              "update:country": function($event) {
                                _vm.country = $event
                              },
                              "update:region": function($event) {
                                _vm.regions = $event
                              },
                              "update:gear": function($event) {
                                _vm.gear = $event
                              },
                              "update:programme": function($event) {
                                _vm.programmeId = ($event || {}).id
                              },
                              "update:year": function($event) {
                                _vm.year = $event
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-card",
                            [
                              _c("h4", [_vm._v("Search for")]),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "text-left pt-2" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "keywordsGroup",
                                            breakpoint: "md",
                                            label: "Keywords",
                                            "label-for": "keywords"
                                          }
                                        },
                                        [
                                          _c("vue-tags-input", {
                                            attrs: {
                                              id: "keywords",
                                              tags: _vm.keywords,
                                              placeholder: "Add keywords..."
                                            },
                                            on: {
                                              "tags-changed": function(
                                                newTags
                                              ) {
                                                return (_vm.keywords = newTags)
                                              }
                                            },
                                            model: {
                                              value: _vm.keyword,
                                              callback: function($$v) {
                                                _vm.keyword = $$v
                                              },
                                              expression: "keyword"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "pt-4" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("toggle-button", {
                                        attrs: {
                                          id: "keywordIsAnd",
                                          labels: {
                                            checked: "Match ALL keywords",
                                            unchecked: "Match ANY keywords"
                                          },
                                          width: 150,
                                          height: 40,
                                          "switch-color": {
                                            checked: "#0069D9",
                                            unchecked: "#218838"
                                          },
                                          color: {
                                            checked: "#278fff",
                                            unchecked: "#30c651"
                                          }
                                        },
                                        model: {
                                          value: _vm.keywordIsAnd,
                                          callback: function($$v) {
                                            _vm.keywordIsAnd = $$v
                                          },
                                          expression: "keywordIsAnd"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-3 pb-3" },
                    [
                      _c(
                        "b-col",
                        [
                          !_vm.loading
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "success" },
                                  on: {
                                    click: function($event) {
                                      _vm.search()
                                    }
                                  }
                                },
                                [_vm._v("Search")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "text-center" },
            [
              _vm.searching
                ? _c("font-awesome-icon", {
                    attrs: { icon: "spinner", size: "lg", spin: "" }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass: "text-center pt-3 pb-3",
              attrs: { "align-h": "center" }
            },
            [
              _c("toggle-button", {
                attrs: {
                  id: "elements-or-dimensions",
                  labels: { checked: "Table", unchecked: "Copy-Paste List" },
                  width: 150,
                  height: 40,
                  "switch-color": { checked: "#0069D9", unchecked: "#218838" },
                  color: { checked: "#278fff", unchecked: "#30c651" }
                },
                model: {
                  value: _vm.displayTable,
                  callback: function($$v) {
                    _vm.displayTable = $$v
                  },
                  expression: "displayTable"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "pl-2 pr-2" },
            [
              _vm.results && _vm.displayTable
                ? _c("table", { staticClass: "table table-striped" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticClass: "text-left" }, [
                          _vm._v("Customer")
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-left" }, [
                          _vm._v("Scoring Event")
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Gear")]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.objectTypeRecommendations
                                ? "Recommendations"
                                : "Quick Wins"
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.results, function(item) {
                          return _c("tr", { key: item.id, staticClass: "c" }, [
                            _c(
                              "td",
                              {
                                staticClass: "text-left text-nowrap align-top"
                              },
                              [
                                _c("b", [
                                  _vm._v(_vm._s(item.surveyRun.customer.name))
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.surveyRun.customer.country) +
                                    "\n            "
                                ),
                                item.surveyRun.customer.region
                                  ? _c("br")
                                  : _vm._e(),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.surveyRun.customer.region) +
                                    "\n            "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.surveyRun.customer.industry) +
                                    " \n            "
                                ),
                                item.surveyRun.customer.secondary_industry
                                  ? _c("br")
                                  : _vm._e(),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      item.surveyRun.customer.secondary_industry
                                    ) +
                                    " \n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "text-left text-nowrap align-top"
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        path:
                                          "/scoring-event/" + item.surveyRun.id
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.surveyRun.period) +
                                        " " +
                                        _vm._s(item.surveyRun.year)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.surveyRun.programme.name) +
                                    " Programme\n          "
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "align-top" }, [
                              _vm._v(_vm._s(item.gear))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-left" }, [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(item.text) }
                              })
                            ])
                          ])
                        }),
                        _vm._v(" "),
                        !_vm.total
                          ? _c("tr", { staticClass: "c" }, [
                              _c("td", { attrs: { colspan: "100" } }, [
                                _vm._v("No results")
                              ])
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.results && !_vm.displayTable
                ? _c(
                    "ol",
                    _vm._l(_vm.results, function(item) {
                      return _c(
                        "li",
                        { key: item.id, staticClass: "text-left" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(item.text) }
                          })
                        ]
                      )
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.total > 0
                ? _c("b-pagination", {
                    attrs: {
                      size: "sm",
                      "total-rows": _vm.total,
                      "per-page": _vm.pageSize
                    },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86ee4d6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86ee4d6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/QuickWinRecommendationSearch.vue
// module id = null
// module chunks = 